import { render, staticRenderFns } from "./LandedCostSettings.vue?vue&type=template&id=0a1895af&scoped=true"
import script from "./LandedCostSettings.vue?vue&type=script&lang=ts"
export * from "./LandedCostSettings.vue?vue&type=script&lang=ts"
import style0 from "./LandedCostSettings.vue?vue&type=style&index=0&id=0a1895af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1895af",
  null
  
)

export default component.exports